import React, { useState, useEffect } from 'react';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import Loading from "../components/layouts/loading";
import { makeStyles } from '@mui/styles';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  minWidth: 1024,
  bgcolor: 'background.paper',
  borderRadius: '6px',
  border: '1px solid #fff',
  boxShadow: 24,
  p: 2,
  textAlign: 'center'
};


const useStyles = makeStyles(theme => ({
  modal: {

    // display: 'flex',
    // alignItems: 'center',
    // justifyContent: 'center',
    '&  .MuiBox-root': {
      height: '100%',
      display: 'flex',
      flexDirection: 'column'
      // backgroundColor: 'red'
    }
  },
  // paper: {
  //     backgroundColor: theme.palette.background.paper,
  //     border: '2px solid #000',
  //     boxShadow: theme.shadows[5],
  //     padding: theme.spacing(2, 4, 3),
  // },
}));

export default function ShowPreview({ onUpdate, src, uri }) {

  const classes = useStyles();

  //Mui Modal
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  //const handleClose = () => setOpenModal(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    handleOpen();
  }, []);

  //Gestione chiusura del modal
  function handleClose(event, reason) {
    //console.log(event, reason);
    switch (reason) {
      case 'backdropClick':
        return;
      case 'escapeKeyDown':
        return;
      default:
        setOpenModal(false);
    }
  }

  return (
    <>
      <Modal
        aria-labelledby="ch-modal-title"
        aria-describedby="ch-modal-description"
        open={openModal}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        className={classes.modal}
      //disableEscapeKeyDown={true} 
      >
        <Fade in={openModal}>
          <Box sx={style} >
            <Typography id="ch-modal-title" variant="h6" component="h2"
              style={{ marginBottom: "20px" }}>
              Widgets Preview {uri}
            </Typography>

            <div className="row" style={{ textAlign: "left", flexGrow: 1 }}>
              <div className="col-12 p-3" style={{}}>
                {isLoading && <Loading />}
                <iframe
                  src={src}
                  title="Preview"
                  style={{ width: "100%", minHeight: "100px", height: '100%' }}
                  sandbox='allow-scripts allow-same-origin'
                  onLoad={() => setIsLoading(false)}>
                </iframe>
                {/* <div DangerlySetInnerHTML={{ __html: "<iframe src='' />"}} /> */}
              </div>
            </div>

            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-secondary"
                  style={{ minWidth: '6rem', marginLeft: '10px', float: "left" }}
                  onClick={() => { onUpdate({}, -1); handleClose(); }}>
                  Chiudi
                </button>
              </div>
              <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <button type="button" className="btn btn-primary"
                  style={{ minWidth: '6rem', marginLeft: '10px', float: "right" }}
                  onClick={() => { window.open(src, '_blank'); }}>
                  Preview in a new tab
                </button>
              </div>
            </div>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}